/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, HFlow, Icon, VFlow } from 'bold-ui'
import { DateField } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { Fragment } from 'react'
import { MetaPath } from 'util/metaPath'

import { ExameQueryModel, ResultadoExameEspecificoModel, ResultadoExameSemSolicitacaoModel } from '../../model'
import { isExameEspecifico } from '../../util'
import { CardResultadoExameContainer } from '../components/CardResultadoExameContainer'
import { ResultadoExameTextAreaField } from '../components/ResultadoExameTextAreaField'
import { ResultadoExameEspecificoField } from '../exames-especificos/ResultadoExameEspecificoField'

interface ResultadoExameSemSolicitacaoFieldProps {
  name: MetaPath<ResultadoExameSemSolicitacaoModel>
  exame: ExameQueryModel
  onRemove(): void
}

export const ResultadoExameSemSolicitacaoField = (props: ResultadoExameSemSolicitacaoFieldProps) => {
  const { name, exame, onRemove } = props

  const handleRemove = () => {
    confirm({
      title: 'Deseja excluir este exame?',
      body: 'Os dados deste exame não serão salvos.',
      confirmLabel: 'Excluir',
      onConfirm: () => onRemove(),
    })()
  }

  const isEspecifico = isExameEspecifico(exame)

  return (
    <CardResultadoExameContainer
      exame={exame}
      headerButtons={
        <Button
          skin='ghost'
          size='small'
          style={css`
            margin: -0.5rem 0;
          `}
          onClick={handleRemove}
        >
          <Icon icon='trashOutline' fill='normal' />
        </Button>
      }
    >
      {isEspecifico ? (
        <ResultadoExameEspecificoField name={name as MetaPath<ResultadoExameEspecificoModel>} exame={exame} />
      ) : (
        <Fragment>
          <ResultadoExameTextAreaField name={name.resultado} />

          <VFlow>
            <div css={tempDateStyle}>
              <DateField name={name.dataSolicitado} label='Solicitado em' maxDate={new Date()} />
            </div>

            <HFlow hSpacing={1.5}>
              <DateField name={name.dataRealizado} label='Realizado em' maxDate={new Date()} />

              <DateField name={name.dataResultado} label='Resultado em' maxDate={new Date()} />
            </HFlow>
          </VFlow>
        </Fragment>
      )}
    </CardResultadoExameContainer>
  )
}

// temp
const tempDateStyle = css`
  & > div {
    display: inline-block;
  }
`
